var _style, _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDjayPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "djayPro",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st2_djayPro{fill-rule:evenodd;clip-rule:evenodd;fill:black;}\n\t.st3_djayPro{opacity:01;fill-rule:evenodd;clip-rule:evenodd;fill:#FFB63C;enable-background:new    ;}\n\t.st4_djayPro{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PRO_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -445.559,
    y1: 406.5401,
    x2: -445.559,
    y2: 405.5401,
    gradientTransform: "matrix(114.184 0 0 -40.544 51210.6211 16494.8867)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#898A8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D7E80"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Combined-Shape_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -843.4688,
    y1: 391.14,
    x2: -843.4688,
    y2: 390.14,
    gradientTransform: "matrix(64 0 0 -50 54014 19547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#898A8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D7E80"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st1_djayPro",
    d: "M64-10v50H0v-50H64z M54-5h-3v40h3V-5z M26-5.3L5.4,35h3.4L26,1.3L43.3,35h3.4L26-5.3z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -442,
    y1: 409.2833,
    x2: -442,
    y2: 408.2833,
    gradientTransform: "matrix(60 0 0 -60 26550 24557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE359"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9500"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    className: "st2_djayPro",
    cx: 30,
    cy: 30,
    r: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    className: "st3_djayPro",
    cx: 30,
    cy: 30,
    r: 12
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st4_djayPro",
    cx: 30,
    cy: 30,
    r: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjayPro);
export default __webpack_public_path__ + "static/media/djayPro.12208083.svg";
export { ForwardRef as ReactComponent };